var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.name)?_c('router-link',{attrs:{"to":_vm.routerURL}},[_vm._v(_vm._s(_vm.title))]):_c('NewTabLink',{attrs:{"linkURL":_vm.scoreURL,"text":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }